var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-link flex flex-col self-start bg-gray-100"},_vm._l((_vm.links),function(link){return _c('AtomLinkItem',{key:link.to,staticClass:"fade-item",class:link.class,attrs:{"to":link.to,"content":link.title}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }